const PAGE_ORIGIN_PARAM = 'listingsPageOrigin';

/**
 * Builds the path reported by page-view tracking: pathname plus search, with
 * the one-shot `listingsPageOrigin` pin stripped so the internal override
 * never reaches analytics.
 */
export const getTrackedPagePath = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const { pathname, search } = window.location;
  const params = new URLSearchParams(search);

  if (!params.has(PAGE_ORIGIN_PARAM)) {
    return `${pathname}${search}`;
  }

  params.delete(PAGE_ORIGIN_PARAM);
  const query = params.toString();

  return `${pathname}${query ? `?${query}` : ''}`;
};
